import { render, staticRenderFns } from "./OrderDetailProductReceipt.vue?vue&type=template&id=b75d7fb6"
import script from "./OrderDetailProductReceipt.vue?vue&type=script&lang=js"
export * from "./OrderDetailProductReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports